import type { ReactNode } from "react";
import { AdminSidebar } from "@/components/AdminSidebar";

export function AdminShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <AdminSidebar />
      <div className="min-h-screen lg:pl-72">{children}</div>
    </div>
  );
}
